export default __webpack_public_path__ + "static/media/Nos.0dbd31e5.jpg";